var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSingleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.175 11.575L9.27495 7.675C9.09162 7.49167 8.99995 7.25833 8.99995 6.975C8.99995 6.69167 9.09162 6.45833 9.27495 6.275C9.45828 6.09167 9.69162 6 9.97495 6C10.2583 6 10.4916 6.09167 10.675 6.275L15.275 10.875C15.475 11.075 15.575 11.3083 15.575 11.575C15.575 11.8417 15.475 12.075 15.275 12.275L10.675 16.875C10.4916 17.0583 10.2583 17.15 9.97495 17.15C9.69162 17.15 9.45828 17.0583 9.27495 16.875C9.09162 16.6917 8.99995 16.4583 8.99995 16.175C8.99995 15.8917 9.09162 15.6583 9.27495 15.475L13.175 11.575Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSingleArrowRight);
export default __webpack_public_path__ + "static/media/ICON_SINGLE_ARROW_RIGHT.26d0e1816d8ea002ea03fcc08471f91b.svg";
export { ForwardRef as ReactComponent };